export class FtpItemInfo {
    constructor(
        public name: string = '',
        public path: string = '',
        public isDocument: boolean = false,
    ) { }
}